import { ENGRAVING_FONTS, toneStyle, zoneFor } from "@/data/engravingPreview";

export const EngravingPreview = ({ product, image, text, fontId }) => {
  const zone = zoneFor(product);
  const font = ENGRAVING_FONTS.find((f) => f.id === fontId) || ENGRAVING_FONTS[0];
  const tone = toneStyle(zone.tone);
  const clean = (text || "").trim();
  const shown = font.transform === "uppercase" ? clean.toUpperCase() : clean;
  const len = Math.max(shown.length, 3);
  const sizeCqw = Math.min(30 * font.scale, 172 / (len * (1 + font.spacing)));

  return (
    <div className="relative overflow-hidden" data-testid="engraving-preview">
      <img key={image} src={image} alt={product.name} className="w-full aspect-square object-cover transition-opacity duration-500" data-testid="product-image" />
      {clean && (
        <div
          className="absolute pointer-events-none flex items-center justify-center"
          style={{ left: `${zone.x}%`, top: `${zone.y}%`, width: `${zone.w}%`, aspectRatio: "3 / 1", transform: `translate(-50%, -50%) rotate(${zone.r}deg)`, containerType: "inline-size" }}
          data-testid="engraving-preview-overlay"
        >
          <div
            className="absolute"
            style={{ inset: "-18% -8%", background: tone.patch, backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)", WebkitMaskImage: "radial-gradient(ellipse at center, #000 45%, transparent 78%)", maskImage: "radial-gradient(ellipse at center, #000 45%, transparent 78%)" }}
          />
          <span
            className="relative whitespace-nowrap leading-none"
            style={{ fontFamily: font.family, fontWeight: font.weight, fontSize: `${sizeCqw}cqw`, letterSpacing: `${font.spacing}em`, color: tone.fill, textShadow: tone.shadow, mixBlendMode: tone.blend }}
            data-testid="engraving-preview-text"
          >
            {shown}
          </span>
        </div>
      )}
      {clean && (
        <span className="absolute bottom-3 left-3 font-mono-tech text-[9px] uppercase tracking-[0.25em] text-zinc-300 bg-black/60 backdrop-blur px-2 py-1" data-testid="engraving-preview-note">
          Live preview · approximate placement
        </span>
      )}
    </div>
  );
};

export const FontPicker = ({ value, onChange }) => (
  <div className="flex flex-wrap gap-2" data-testid="font-picker">
    {ENGRAVING_FONTS.map((f) => (
      <button
        key={f.id}
        type="button"
        onClick={() => onChange(f.id)}
        data-testid={`font-${f.id.toLowerCase().replace(/[^a-z]+/g, "-")}`}
        aria-pressed={value === f.id}
        className={`px-4 py-2 border transition-colors text-base leading-none ${value === f.id ? "border-[#C87455] text-white bg-[#C87455]/10" : "border-zinc-800 text-zinc-400 hover:border-zinc-600"}`}
        style={{ fontFamily: f.family, fontWeight: f.weight, textTransform: f.transform, letterSpacing: `${f.spacing / 2}em` }}
      >
        {f.id}
      </button>
    ))}
  </div>
);
